<style scoped>
</style>

<template>
	<div class="vue-box">
		<div class="c-panel">

			<!-- 参数栏 -->
			<div class="c-title">补课列表</div>
			<el-form size="mini" :inline="true" @submit.native.prevent >

        <el-form-item label="老师：">
          <el-select size="mini" v-model="p.teaId">
            <el-option label="不限" :value="''"></el-option>
            <el-option v-for="tea in teacherList" :label="tea.name" :value="tea.id" :key="tea.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态：">
          <el-select size="mini" v-model="p.status">
            <el-option label="不限" :value="''"></el-option>
            <el-option label="初始" :value="0"></el-option>
            <el-option label="计划" :value="1"></el-option>
            <el-option label="上完" :value="2"></el-option>
            <el-option label="取消" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="min-width: 0px;">
          <el-button type="primary" icon="el-icon-search" @click="p.pageNo = 1; f5()">查询</el-button>

        </el-form-item>
			</el-form>
			<!-- 数据列表 -->
			<div class="c-title">补课列表</div>
			<el-table :data="dataList" size="mini">
        <el-table-column label="补课状态" width="80px">
          <template slot-scope="s">
            <el-tag class="c-tag" effect="dark" size="mini" color="#33ccff" v-if="s.row.status==0">初始</el-tag>
            <el-tag class="c-tag" effect="dark" size="mini" color="#0066ff" v-if="s.row.status==1">计划</el-tag>
            <el-tag class="c-tag" effect="dark" size="mini" color="#00ff66" v-if="s.row.status==2">上完</el-tag>
            <el-tag class="c-tag" effect="dark" size="mini" color="#cc3366" v-if="s.row.status==3">取消</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="学生" prop="stuName"  width="200px"></el-table-column>
				<el-table-column label="班级" prop="clazzName"  width="200px"></el-table-column>
        <el-table-column label="补课老师" width="200px">
          <template slot-scope="s">
            <span style="color: #000000; ">{{getTeacherName(s.row.teaId)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="补课日期" width="150px">
          <template slot-scope="s"><span>{{sa.forDate(s.row.newDate, 2)}}</span></template>
        </el-table-column>
        <el-table-column label="创建日期" width="150px">
          <template slot-scope="s"><span>{{sa.forDate(s.row.createTime, 2)}}</span></template>
        </el-table-column>
				<el-table-column label="操作" width="400px">
					<template slot-scope="s">
						<el-button v-if="s.row.status=='0'||s.row.status=='1'" class="c-btn" type="primary" icon="el-icon-edit" @click="update(s.row)">安排时间</el-button>
            <el-button v-if="s.row.status=='1'" class="c-btn" type="success"  icon="el-icon-check" @click="changeStatus(s.row.id,2)">消课</el-button>
            <el-button v-if="s.row.status=='0' && s.row.newDate!=null" class="c-btn" type="success"  icon="el-icon-check" @click="changeStatus(s.row.id,1)">确定时间</el-button>
            <el-button v-if="s.row.status=='0'" class="c-btn" type="danger" icon="el-icon-error" @click="changeStatus(s.row.id,3)">退还课时</el-button>
            <el-button v-if="s.row.status=='0'" class="c-btn" type="danger" icon="el-icon-error" @click="changeStatus(s.row.id,4)">删除</el-button>

					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="page-box">
				<el-pagination background
					layout="total, prev, pager, next, sizes, jumper"
					:current-page.sync="p.pageNo"
					:page-size.sync="p.pageSize"
					:total="dataCount"
					:page-sizes="[1, 10, 20, 30, 40, 50, 100]"
					@current-change="f5()"
					@size-change="f5()">
				</el-pagination>
			</div>
		</div>

		<!-- 增改组件 -->
		<add-or-update ref="add-or-update"></add-or-update>
	</div>
</template>

<script>
	import addOrUpdate from './absent-list-add.vue';
	export default {
		components: {
			addOrUpdate
		},
		data() {
			return {
			  subList:[],
        teacherList:[],
				p: {		// 查询参数
					pageNo: 1,
					pageSize: 10,
          teaId:'',
          status:0
				},
				dataCount: 0,
				dataList: [],		// 数据集合
			}
		},
		methods: {
			// 刷新
			f5: function(){
        let data = {
          subId:this.p.subId,
          pageNum:this.p.pageNo,
          pageSize:this.p.pageSize,
          teaId:this.p.teaId,
          status:this.p.status,
          quarter:this.p.quarter,
          year:this.p.year
        }
				this.sa.ajax('api/psdAdmin/absent/getList',
            data,
            function(res){
				  if(res.code == 0) {
            this.dataList = res.data.data;	// 数据
            this.dataCount = res.data.pageCount;	// 分页
            console.log(res.data);
          }else{
            this.dataList=[];
            this.dataCount=0;
            this.sa.error(res.msg || '补课列表获取失败');
          }
				}.bind(this)/*, {res: mockDataList}*/);
			},
      openClazzCard:function (data){
        var tab = {id: '101-'+data.id, name: '['+data.name+'] 课表', view: () => import('@/sa-view/clazzCard/clazz-card-list.vue'), params:{id:data.id,name:data.name}};
        this.sa_admin.showTab(tab);
      },
			// 添加
			add: function () {
				this.$refs['add-or-update'].open(0);
			},
			// 修改
			update: function (data) {
				this.$refs['add-or-update'].open(data.id);
			},
			// 删除
      viewStu: function (data) {
        var tab = {id: '102-'+data.id, name: '['+data.name+'] 学生列表', view: () => import('@/sa-view/clazz/clazz-stu-list.vue'), params:{id:data.id,name:data.name}};
        this.sa_admin.showTab(tab);
			},
      changeStatus:function (id,status){
			  let _this = this;
			  let des = '';
			  if(status == 1){
			    des='确定时间后会向家长推送补课提醒';
        }else if(status==2){
			    des = '确定后该补课信息即算成功';
        }else if(status==3){
			    des = '确定后补课信息关闭，退还扣除课时';
        }else if(status==4){
			    des = '确定后直接取消补课，不退还课时（用于误操作将学生摄入补课）';
        }
        this.sa.confirm(des,function (){
          _this.sa.ajax('api/psdAdmin/absent/setAbsentStatus',
              {id:id,status:status},
              function(res){
                if(res.code=='0'){
                  _this.sa.alert("已变更",function (){
                    _this.f5();
                  });
                }else{
                  _this.sa.error("变更失败");
                }
              }.bind(this));
        });

      },
      getSubList:function (){
        this.sa.ajax('api/psdAdmin/subject/getList',
            {},
            function(res){
              this.subList = res.data;
              console.log('科目',res.data);
            }.bind(this),{async:false});
      },
      getSubName:function (id){
        for(let i=0;i<this.subList.length;i++){
          if(this.subList[i].id == id){
            return this.subList[i].name;
          }
        }
        return id;
      },
      getTeacherList:function (){
        this.sa.ajax('api/psdAdmin/teacher/getList',
            {},
            function(res){
              this.teacherList = res.data;
              console.log('老师',res.data);
            }.bind(this),{async:false});
      },
      getTeacherName:function (id){
        for(let i=0;i<this.teacherList.length;i++){
          if(this.teacherList[i].id == id){
            return this.teacherList[i].name;
          }
        }
        return id;
      },
      getYearList:function (){
        this.sa.ajax('api/psdAdmin/clazz/getYearList',
            {},
            function(res){
              this.yearList = res.data;
              console.log('年份',res.data);
            }.bind(this),{async:false});
      },
		},
		created: function(){
      this.getTeacherList();
      this.getSubList();
      this.getYearList();
			this.f5();
			// this.$notify.info({
			// 	title: '消息',
			// 	message: '本页面展示表格的常见显示方式'
			// });
		},
    filters: {

    }
	}
</script>
